/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { downloadAsset } from './utils/helpers';
import { Container, Form } from './styles/index.styled';
import HubspotEmbedForm from '../HubspotEmbed';
import { handleUTMsEvent } from '../Utilities/hubspotEmbedGetUTMs';

const DownloadDetailForm = ({ component }) => {
  const { t } = useTranslation();

  const handleFormSubmit = event => {
    console.log('Form submission event triggered:', event);
    if (component && component.internalName && component.download) {
      downloadAsset(component.internalName, component.download);
    } else {
      console.error('Missing download properties:', component);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('hs-form-event:on-ready', handleUTMsEvent);

      return () => {
        window.removeEventListener('hs-form-event:on-ready', handleUTMsEvent);
      };
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'hs-form-event:on-submission:success',
        handleFormSubmit
      );

      return () => {
        window.removeEventListener(
          'hs-form-event:on-submission:success',
          handleFormSubmit
        );
      };
    }
  }, [component]);

  return (
    <Container>
      <p className="heading">{t('Unlock Your All Access Pass')}</p>
      <Form>
        <HubspotEmbedForm
          portalId="243522351"
          formId="d5c50925-4241-49df-a845-52e9ed4b9ec6"
          region="na2"
        />
      </Form>
    </Container>
  );
};

export default DownloadDetailForm;
